import React from 'react';
import { Flex } from '@withjoy/joykit';
import { PriceRange } from '../../../PriceRange/PriceRange';
import type { RefinementFacetProps } from '../../RefinementFacet.types';
import { RefinementFacetBase } from '../RefinementFacetBase';
import { RefinementFacetPriceBuckets } from '../RefinementFacetPriceBuckets';
import { useRefinementFacetPriceRange } from './RefinementFacetPriceRange.controller';
import { useTranslation } from '@shared/core';

export interface RefinementFacetPriceRangeProps extends RefinementFacetProps {}

const RefinementFacetPriceRange = (props: RefinementFacetPriceRangeProps) => {
  const { currentBucketOptions, handleBucketChange, currentPriceRange, handlePriceChange } = useRefinementFacetPriceRange(props);
  const { tq } = useTranslation('catalogRegistry');

  return (
    <RefinementFacetBase
      title={tq`Price`}
      groupCode={props.filter.attributeGroup.code}
    >
      <Flex
        flexDirection="column"
        paddingLeft={5}
        rowGap={6}
      >
        <RefinementFacetPriceBuckets
          options={currentBucketOptions}
          onChange={handleBucketChange}
        />
        <PriceRange
          onChange={handlePriceChange}
          value={currentPriceRange}
        />
      </Flex>
    </RefinementFacetBase>
  );
};

export { RefinementFacetPriceRange };
